import React, { useEffect, useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { CheckCircle, ArrowRight } from 'lucide-react';
import Button from '../components/common/Button';
import { useNavigate } from 'react-router-dom';

const PaymentSuccessPage: React.FC = () => {
  const { t } = useLanguage();
  const navigate = useNavigate();
  const redirectSeconds = 12;
  const [secondsLeft, setSecondsLeft] = useState(redirectSeconds);

  useEffect(() => {
    const interval = setInterval(() => {
      setSecondsLeft((prev) => (prev > 1 ? prev - 1 : 1));
    }, 1000);
    const timeout = setTimeout(() => navigate('/'), redirectSeconds * 1000);

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, [navigate, redirectSeconds]);

  return (
    <div className="min-h-screen bg-neutral-50 flex items-center justify-center px-4 py-16">
      <div className="relative w-full max-w-xl">
        <div className="relative card p-8 sm:p-10 text-center shadow-large">
          <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-2xl bg-primary-500 text-white shadow-medium">
            <CheckCircle size={32} />
          </div>
          <h1 className="mt-6 text-2xl sm:text-3xl font-bold text-neutral-900">
            {t('checkout.successTitle')}
          </h1>
          <p className="mt-3 text-base text-neutral-600 leading-relaxed">
            {t('checkout.successMessage')}
          </p>
          <p className="mt-6 text-sm text-neutral-500" aria-live="polite">
            {t('checkout.successRedirect', { seconds: secondsLeft })}
          </p>
          <div className="mt-6 flex flex-col sm:flex-row gap-3 justify-center">
            <Button
              variant="primary"
              size="lg"
              onClick={() => navigate('/')}
              icon={<ArrowRight size={18} />}
              iconPosition="right"
            >
              {t('common.backToHome')}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccessPage;
